<template>
  <!-- 订舱 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>美加到门</el-breadcrumb-item>
        <el-breadcrumb-item>查询结果</el-breadcrumb-item>
        <el-breadcrumb-item class="bread">我要下单</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 模版 -->
      <div class="template">
        <div class="left">
          <div class="shiyopng">
            使用订舱模板
            <span class="wode">我的模板</span>
          </div>
          <div>使用订舱模板，快捷填写一键下单</div>
        </div>
        <div class="right">
          <div @click="getTemplate">
            选择模板
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
       <div class="CargoInformation phone-info">
        <div class="title">货物信息</div>
        <div class="info">
          <i class="el-icon-info"></i>
          <span>*</span>号代表必填项
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word">国家</div>
            <el-input disabled v-model="parameter.country_name" placeholder="请输入内容"></el-input>
          </div>
          <!-- <div class="yi1">
            <div class="word">{{parameter.type==1?'起运港':'卸货港'}}</div>
            <el-input disabled v-model="parameter.state_port_name" placeholder="请输入内容"></el-input>
          </div> -->
          <div class="yi1">
            <div class="word"><span>*</span>{{parameter.type==1?'卸货港/卸货地':'装货港/装货地'}}</div>
            <el-input disabled v-model="parameter.end_place_name" placeholder="请输入内容"></el-input>
          </div>
          <div>
            <div class="word"><span>*</span>{{parameter.type==1?'送达城市(邮编)':'起运城市(邮编)'}}</div>
            <el-input disabled v-model="parameter.state_port_name" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>最终目的地/联系人/电话/联系邮箱</div>
            <el-input
              type="textarea"
              v-model="searchForm.dest_address"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
      <!-- 其他信息 -->
      <div class="CargoInformation phone-info">
        <div class="title">货物信息</div>
        <div class="info">
          <i class="el-icon-info"></i>
          <span>*</span>号代表必填项
        </div>
        <div class="info-shang input">
          <div
            class="yi"
            v-for="(item, index) in inputList"
            :key="index"
            :class="(index + 1) % 4 == 0 ? 'yi2' : 'yi'"
          >
            <div class="yiii">
              <div class="word"><span>*</span>箱型</div>
              <el-select
                clearable
                v-model="item.cases_gauge_type_id"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in boxTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="yiii">
              <div class="word"><span>*</span>箱号</div>
              <el-input v-model="item.boxno" placeholder="请输入"></el-input>
            </div>
            <div>
              <div class="word"><span>*</span>单箱重量(kg)</div>
              <el-input min='0' type="number" @blur="onBlur" v-model="item.weight" placeholder="请输入"></el-input>
            </div>
            <i @click="removeRow(index)" class="el-icon-delete"></i>
          </div>
        </div>
        <div class="add" @click="addRow">
          <i class="el-icon-circle-plus-outline"></i>
          <div>新增集装箱</div>
        </div>

        <div class="info-shang">
          <div>
            <div class="word"><span>*</span>总重量(kg)</div>
            <el-input min='0' type="number" @blur="onBlur" v-model="searchForm.total_weight" placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div class="info-shang">
          <div class="yi1">
            <div class="word">订舱联系人</div>
            <el-input v-model="searchForm.order_username" placeholder="请输入内容"></el-input>
          </div>
          <div class="yi1">
            <div class="word">联系人电话</div>
            <el-input @blur="validDianhua" v-model="searchForm.order_phone" placeholder="请输入内容"></el-input>
          </div>
          <div
            class="yi"
            v-for="(item, index) in emailList"
            :key="index"
            :class="(index + 3) % 4 == 0 ? 'yi2' : 'yi'"
          >
            <div class="word"><span>*</span>联系人邮箱</div>
            <div class="ipt_del">
              <el-input @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
              <div @click="removeEmail(index)" class="delete">删除</div>
            </div>
          </div>
        </div>

        <div class="add" @click="addEmail">
          <i class="el-icon-circle-plus-outline"></i>
          <div>新增联系人邮箱</div>
        </div>

        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>船东</div>
            <el-select
              v-model="searchForm.shipowner_id"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in shippingList"
                :key="item.id"
                :label="item.name_cn + '-' + item.name_en"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>航名/航次</div>
            <el-input v-model="searchForm.vessel_voyage" placeholder="请输入内容"></el-input>
          </div>
          <div class="yi1">
            <div class="word">销售代码</div>
            <el-input readonly v-model="searchForm.sales_code" placeholder="请输入内容"></el-input>
          </div>
        </div>

        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>提单类型</div>
            <div class="zhufen">
              <div @click="searchForm.order_type = 1" :class="{ 'is-active': searchForm.order_type == 1 }">
                主单
              </div>
              <div @click="searchForm.order_type = 2" :class="{ 'is-active': searchForm.order_type == 2 }">
                分单
              </div>
            </div>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>运输模式</div>
            <div class="moshi">
              <div @click="searchForm.transport_mode = 1" :class="{ 'moshiis-active': searchForm.transport_mode == 1 }">
                DAP
              </div>
              <div @click="searchForm.transport_mode = 2" :class="{ 'moshiis-active': searchForm.transport_mode == 2 }">
                DDU
              </div>
              <div @click="searchForm.transport_mode = 3" :class="{ 'moshiis-active': searchForm.transport_mode == 3 }">
                DDP
              </div>
            </div>
          </div>
          <div class="yi1">
            <div class="word"><span>*</span>主单提单号</div>
            <el-input v-model="searchForm.mawb_blno" placeholder="请输入内容"></el-input>
          </div>
          <div>
            <div class="word">分单提单号</div>
            <el-input v-model="searchForm.split_order_blno" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="info-shang">
          <div class="yi1">
            <div class="word"><span>*</span>分单目的港代理联系人信息</div>
            <el-input
              type="textarea"
              v-model="searchForm.split_order_address"
              placeholder="请输入内容"
            ></el-input>
          </div>
          <div>
            <div class="word">订单备注</div>
            <el-input
              type="textarea"
              v-model="searchForm.order_remarks"
              placeholder="请输入内容"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="fukuan">
      <div class="fk-content typeArea">
        <div class="fk-left">
          <div>拖车费合计：<span>${{parameter.price}}</span></div>
          <div>总里程：<span>{{parameter.distance}} mi</span></div>
        </div>
        <div class="fk-right">
          <el-button class="fanhui" @click="$router.push('/USToDoor')"
            >返回</el-button
          >
          <el-button class="tijiao" @click="submit"
            >提交订舱</el-button
          >
        </div>
      </div>
    </div>
    <Bottom />

    <!-- 模版弹窗 -->
    <el-dialog title="我的模版" :visible.sync="dialogTableVisible">
      <el-table ref="table" :data="gridData" @expand-change="expandChange">
        <el-table-column width="180" label="模版编号">
          <template slot-scope="scope">
            <el-radio v-model="mobanRadio" :label="scope.row.id"></el-radio>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="180"
          property="id"
          
        ></el-table-column> -->
        <el-table-column
          property="template_name"
          label="模版名称"
        ></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- 展开内容 -->
            <span>展开{{ props.row.template_name }}</span>

            <div class="modelDetail">
              <!-- 最终目的地/联系人/电话/联系邮箱 -->
              <div class="detail">
                <div class="de-con de-consan de-conwu">
                  <div>
                    <div class="de-tit">最终目的地/联系人/电话/联系邮箱</div>
                    <div class="conyi">
                      <p>{{templateForm.dest_address}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 下单联系人 -->
              <div class="detail">
                <div class="de-con">
                  <div>
                    <div class="de-tit">下单联系人</div>
                    <div class="conyi">
                      <div>{{templateForm.order_username}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">联系人电话</div>
                    <div class="conyi">
                      <div>{{templateForm.order_phone}}</div>
                    </div>
                  </div>
                  <div v-for="(item, index) in templateForm.email" :key="index">
                    <div class="de-tit">联系人邮箱</div>
                    <div
                      class="conyi"
                      :class="(index + 3) % 4 == 0 ? 'coner' : ''"
                    >
                      <div>{{ item }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 船东 -->
              <div class="detail">
                <div class="de-con">
                  <div>
                    <div class="de-tit">船东</div>
                    <div class="conyi">
                      <div>{{templateForm.shipowner_name}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">航名/航次</div>
                    <div class="conyi">
                      <div>{{templateForm.vessel_voyage}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">销售代码</div>
                    <div class="conyi">
                      <div>{{templateForm.sales_code}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 提单类型 -->
              <div class="detail">
                <div class="de-con">
                  <div>
                    <div class="de-tit">提单类型</div>
                    <div class="conyi">
                      <div>
                        {{templateForm.order_type == 1 ? '主单':'分单'}}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">运输模式</div>
                    <div class="conyi">
                      <div>
                        {{
                          templateForm.transport_mode == 1 ? 
                          'DAP':
                          (templateForm.transport_mode == 2 ? 'DDU' : 'DDP')
                          }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">主单提单号</div>
                    <div class="conyi">
                      <div>{{templateForm.mawb_blno}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">分单提单号</div>
                    <div class="conyi coner">
                      <div>{{templateForm.split_order_blno}}</div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- 订单备注 -->
              <div class="detail">
                <div class="de-con de-coner de-consan">
                  <div>
                    <div class="de-tit">分单目的港代理联系人信息</div>
                    <div class="conyi">
                      <p>
                        {{templateForm.split_order_address}}
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="de-tit">订单备注</div>
                    <div class="conyi">
                      <p>{{templateForm.order_remarks}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">返回</el-button>
        <el-button type="primary" @click="useTemplate"
          >使用模版</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
   
<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  mjdmTemplateAalidList,
  baseCasesGaugeTypeValidList,
  baseShippingCompanyValidList,
  MjdmOnlineInquiryRecordsAddOrder,
  mjdmTemplateDetail
} from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      inputList: [{ cases_gauge_type_id: "",boxno:'',weight:'' }],
      num: 0,
      emailList: [{ email: "" }],
      // 付款方式  预付到付
      radio: "1",

      // 模版弹窗是否出现
      dialogTableVisible: false,
      // 弹窗表格展示的模版列表
      gridData: [],
      // 选中模版
      mobanRadio: "",
      // 价格明细抽屉是否打开
      table: false,
      moshi: 1,
      headers: {
        token: localStorage.getItem("token"),
      },
      total: 0,
      boxTypeList: [],
      shippingList: [],
      searchForm:{
        type:'', // 进出口：1出口、2进口
        country_id:'', // 国家id
        state_port_id:'', // 起运港ID | 卸货港ID
        end_city_id:'', // 送达城市ID | 起运城市ID
        port_id:'', // 卸货港、卸货地ID | 装货港、装货地ID
        price:'', // 费用
        dest_address:'', // 最终目的地地址/联系人/电话/邮箱
        order_type:'1', // 订单类型：1主单、2分单
        split_order_address:'', // 分单目的港联系人/电话/邮箱
        total_weight:'', // 总重量（kg）
        order_username:'', // 下单委托人
        order_phone:'', // 下单委托人电话
        vessel_voyage:'', // 船名/航次
        shipowner_id:'', // 船东ID
        mawb_blno:'', // 主单提单号
        split_order_blno:'', // 分单提单号
        transport_mode:'1', // 运输模式
        sales_code:'', // 销售代码
        order_remarks:'', // 订单备注
        country_name:'', // 国家名字
        state_port_name:'', // 起运港口名称
        end_place_name:'', // 送达地名称
        port:'', // 卸货地卸货港
        goods:[], // 货物信息：[{'cases_gauge_type_id':1, 'boxno':'箱号', 'weight':'单箱重量（kg）'}]
        email:[], // 下单委托人邮箱：['111','222']
      },
      // 页面跳转带来的参数
      parameter:{},
      // 模版列表展开行 id
      expandKeyId:undefined,
      // 模版表单
      templateForm:{},
    };
  },
  methods: {
    addRow() {
      this.inputList.push({ cases_gauge_type_id: "",boxno:'',weight:'' }); // 添加新行
    },
    removeRow(index) {
      if(this.inputList.length==1){
        this.$message({
          type:'error',
          message:'最少要填写一个'
        })
      }else{
        this.inputList.splice(index, 1); // 删除指定行
      }
    },
    addEmail() {
      this.emailList.push({ email: "" }); // 添加新行
    },
    removeEmail(index) {
      if(this.emailList.length==1){
        this.$message({
          type:'error',
          message:'最少要填写一个'
        })
      }else{
        this.emailList.splice(index, 1); // 删除指定行
      }
    },
    // 模版列表
    async getTemplate() {
      this.dialogTableVisible = true;
      let form = {
        page_no: "1",
        page_size: "10",
      };
      try {
        const res = await mjdmTemplateAalidList(form, this.headers);
        if (res.code == 1) {
          this.gridData = res.data.lists;
          this.total = res.data.count;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 箱型
    async getBoxTypeList() {
      // 目的港列表
      const res = await baseCasesGaugeTypeValidList();
      if (res.code == 1) {
        this.boxTypeList = res.data;
      }
    },
    // 船公司
    async getShippingList() {
      const res = await baseShippingCompanyValidList();
      if (res.code == 1) {
        this.shippingList = res.data;
      }
    },
    // 提交订舱
    async submit(){
      // this.$router.push('/USToDoor')

      this.searchForm.type = this.parameter.type
      this.searchForm.country_id = this.parameter.country_id
      this.searchForm.state_port_id = this.parameter.state_port_id
      this.searchForm.end_city_id = this.parameter.end_city_id
      // -----------
      this.searchForm.port = this.parameter.port_id
      this.searchForm.port_id = this.parameter.port_id
      this.searchForm.price = this.parameter.price
      // -----------
      this.searchForm.country_name = this.parameter.country_id
      this.searchForm.state_port_name = this.parameter.state_port_name
      this.searchForm.end_place_name = this.parameter.end_place_name
      this.searchForm.distance = this.parameter.distance


      this.searchForm.goods = this.inputList
      this.searchForm.email = []


      for (let i = 0; i < this.emailList.length; i++) {
        this.searchForm.email.push(this.emailList[i].email)
      }

      try {
        const res = await MjdmOnlineInquiryRecordsAddOrder(this.searchForm,this.headers)
        if(res.code==1){
          this.$message({
            type:'success',
            message:'提交成功'
          })
          // let url = this.canshu.type==1 ? 'freight':'market'
          // this.$router.push({
          //   name:'USToDoorOrderDetails',
          //   params:this.searchForm
          // })
          this.$router.push('/USToDoor')
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 打开关闭模版详情  查看模版详情
    // expandChange(row,expandedRows){
    // },
    expandChange(row, expandedRows) {
      if (expandedRows.length == 1) {
        if (!this.expandKeyId) {
          this.expandKeyId = row.id;
        }
        this.getTemplateDetail(this.expandKeyId) // 获取详情接口
      } else if (expandedRows.length >= 2) {
        //已经展开一行
        this.expandKeyId = expandedRows[expandedRows.length - 1].id; //获取最后一个点开的rowID
        this.getTemplateDetail(this.expandKeyId)
        //遍历表格数据，关闭其他的展开行
        this.gridData.map(item => {
          if (item.id != this.expandKeyId) {
            this.$refs.table.toggleRowExpansion(item, false);
          }
        })
      } else {
        //关闭
        this.expandKeyId = undefined;
        this.expandData = [];
      }
    },
    // 获取模版详情
    async getTemplateDetail(e){
      try {
        const res = await mjdmTemplateDetail({
          id:e
        },this.headers)
        if (res.code==1) {
          this.templateForm=res.data
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    async useTemplate(){
      try {
        const res = await mjdmTemplateDetail({
          id:this.mobanRadio
        },this.headers)
        if (res.code==1) {
          this.searchForm.dest_address=res.data.dest_address
          this.searchForm.order_type=res.data.order_type
          this.searchForm.order_username=res.data.order_username
          this.searchForm.order_phone=res.data.order_phone
          this.searchForm.vessel_voyage=res.data.vessel_voyage
          this.searchForm.shipowner_id=res.data.shipowner_id
          this.searchForm.mawb_blno=res.data.mawb_blno
          this.searchForm.split_order_blno=res.data.split_order_blno
          this.searchForm.transport_mode=res.data.transport_mode
          this.searchForm.sales_code=res.data.sales_code
          this.searchForm.order_remarks=res.data.order_remarks
          this.searchForm.email=res.data.email
          this.searchForm.split_order_address=res.data.split_order_address

          this.emailList=[]
          for (let i = 0; i < res.data.email.length; i++) {
              this.emailList.push({'email':res.data.email[i]})
          }

          this.dialogTableVisible = false
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
     // 校验邮箱
     validEmsil(e) {
      let emial = e.target.value
      if(emial==''){
        return
      }
      if (emial == "" || emial == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          emial
        )
      ) {
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 校验手机号
    validDianhua() {
      let dianhua = this.searchForm.order_phone
      if(dianhua==''){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 输入的数字大于0
    onBlur(e){
     if(e.target.value == ''){
        return
      }
      if(!/\d$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为数字'
        })
      }
    },
  },
  mounted() {
    this.parameter = this.$route.params
    this.searchForm.sales_code = this.parameter.kefu_info.sales_code
    this.getBoxTypeList();
    this.getShippingList();
  },
};
</script>

<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.template {
  box-sizing: border-box;
  height: 122px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #606260;
    text-align: left;
    font-style: normal;
    text-transform: none;
    .shiyopng {
      color: #0073f5;
      font-size: 20px;
      margin-bottom: 8px;

      .wode {
        margin-left: 9px;
        display: inline-block;
        width: 80px;
        height: 28px;
        background: #edf6ff;
        border-radius: 4px 4px 4px 4px;

        font-size: 14px;

        text-align: center;
        line-height: 28px;
      }
    }
  }

  .right {
    height: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    cursor: pointer;
  }
}
.shang {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 164px;
  border-bottom: #eee solid 1px;
  .logo {
    width: 48px;
    height: 48px;
    margin-right: 120px;
  }
  .qiyun {
    // width: 120px;
    .date {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 19px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin-bottom: 4px;
    }
    .address {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dao {
    width: 100px;
    text-align: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    font-style: normal;
    text-transform: none;

    margin: 0 48px;
    img {
      width: 100px;
      height: 7px;
    }
    div {
      height: 12px;
    }
  }
}

.zhong {
  display: flex;

  margin-top: 24px;
  margin-bottom: 12px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  div {
    margin-right: 48px;
  }
  .kuan {
    width: 130px;
  }
}

.xia {
  display: flex;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .kuan {
    width: 130px;
    margin-right: 48px;

    display: flex;
  }

  .kuan:nth-child(2) {
    width: 132px;
    margin-right: 42px;
  }
  .cilick {
    cursor: pointer;
    color: #0073f5;
  }
  .youbian {
    margin-right: 115px;
  }
}

.CargoInformation {
  // height: 401px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;

  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .info {
    font-size: 14px;
    color: #999;
    margin-top: 10px;

    .el-icon-info {
      color: #ccc;
    }
    span {
      font-size: 14px;
      color: #fe3300;
    }
  }

  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .info-shang {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    .word {
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #606260;
      span {
        color: #fe3300;
      }
    }
    :deep(.el-input) {
      input {
        width: 266px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
        color: #333;
      }
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 556px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }
  .input {
    display: flex;
    flex-wrap: wrap;
    .yi {
      display: flex;
      // align-items: center;
      margin-right: 24px;
      margin-bottom: 20px;
    }

    .yi2 {
      display: flex;
      // align-items: center;
      margin-right: 24px;
      margin-right: 0px;
      margin-bottom: 20px;
    }

    .yiii {
      margin-right: 48px;
    }
    :deep(.el-input) {
      width: 242px;
      input {
        width: 242px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }

    .el-icon-delete {
      color: #606260;
      margin-left: 8px;
      cursor: pointer;

      font-size: 16px;
      margin-top: 45px;
    }
  }

  .add {
    width: 120px;
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #0073f5;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
    i {
      margin-right: 4px;
      font-size: 16px;
    }
  }

  .info-shoufat {
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 362px;
      }
    }
  }

  .zhufen {
    width: 266px;
    height: 44px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    padding: 6px;
    box-sizing: border-box;
    div {
      width: 120px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
    }
    .is-active {
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
    }
  }

  .moshi {
    width: 266px;
    height: 44px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    padding: 6px;
    box-sizing: border-box;
    div {
      width: 80px;
      color: #999999;
      font-size: 14px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      cursor: pointer;
    }
    .moshiis-active {
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
    }
  }
}

.shoufat {
  height: 305px;
  :deep(.el-textarea) {
    .el-textarea__inner {
      width: 362px;
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    width: 120px;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 1136px;
      }
    }
  }
}

.update {
  .title {
    margin-top: 24px;
    margin-bottom: 24px;
  }
  .shangchuan {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
  }

  .btn {
    display: flex;
    margin-top: 12px;
    .sc_btn {
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      color: #0073f5;
      font-size: 14px;
      border: 0;
    }
  }

  .upload-demo {
    width: 266px;
    margin-right: 24px;
  }

  .updateList {
    // margin-top: 12px;

    display: flex;
    align-items: baseline;

    i {
      font-size: 16px;
      color: #00b53c;
      margin-right: 9px;
    }

    .name {
      width: 130px;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #0073f5;
      font-style: normal;
      text-transform: none;
    }

    .el-butnm {
      color: #fe3300;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      font-style: normal;
      text-transform: none;

      height: 24px;
    }

    .del {
      color: #0073f5;
      margin-left: 53px;
    }
  }
}

.fukuan {
  // width: 1920px;
  height: 118px;
  background: #ffffff;

  .fk-content {
    height: 118px;

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .fk-left {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 14px;
      font-style: normal;
      text-transform: none;
      div {
        margin-top: 8px;
      }
      span {
        color: #fe3300;
      }
    }

    .fk-right {
      .fanhui {
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        color: #999999;
        background: #f9f9f9;

        margin-left: 24px;
        border: 0;
        margin-right: 16px;
      }

      .tijiao {
        width: 100px;
        height: 40px;
        background: #0073f5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
      }
    }
  }
}

.modelDetail {
  .detail {
    margin-top: 24px;
    .de-tit {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }

    .de-con {
      display: flex;
      flex-wrap: wrap;
      .conyi {
        width: 213px;
        height: 40px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        margin-right: 17px;
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        div {
          // line-height: 40px;
          // padding-left: 12px;
          // padding-right: 12px;
          padding: 12px;
          width: 213px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .coner {
        margin-right: 0px;
      }
    }

    .de-coner {
      justify-content: space-between;
      .conyi {
        margin-right: 0px;
      }
    }

    .de-consan {
      .conyi {
        width: 446px;
        height: 140px;

        padding: 12px;

        p {
          line-height: 16px;
          margin: 0;
        }
      }
    }

    .de-consi {
      .conyi {
        width: 290px;
        height: 140px;
      }
    }

    .de-conwu {
      .conyi {
        width: 910px;
        height: 140px;
      }
    }

    .con-up {
      display: flex;
      align-items: center;
      i {
        font-size: 16px;
        color: #00b53c;
        margin-right: 9px;
      }

      .name {
        width: 130px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .el-butnm {
        color: #0073f5;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-transform: none;

        height: 18px;
        padding: 0;
      }
    }
  }
}

.el-drawer {
  .drawer-title {
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span {
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i {
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det {
    padding: 32px 32px 0 32px;
  }

  .tab-tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }

  .table {
    width: 100%;
    border-spacing: 0;

    border-bottom: solid 1px #eee;
    .theader {
      height: 48px;
      background: #f9f9f9;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }
    .first {
      padding-left: 24px;
      width: 320px;
    }
    .tbody {
      height: 68px;
      background: #fff;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      font-style: normal;
      text-transform: none;
    }
  }

  .drawer__footer {
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao {
      width: 100px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg {
      width: 100px;
      height: 40px;
      background: #0073f5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}

.el-table{
  width: 100%;
}
</style>